var site = site || {};
(function ($) {
  site.productView = site.productView || {};

  site.productView.mppshape = {
    extendedMPPRows: [],
    init: function(productsData) {
      var that = this;
      var $mppProductGrids = $('.js-mpp-product-grid');
      if ($mppProductGrids.length === 0) {
        return;
      }
      // all products, grids and rows
      var $allMppProducts = $('.js-product-brief', $mppProductGrids);
      var mppGridsRows = [];
      var allMppRows = [];
      var $mppProducts;
      var mppRows = [];
      var $mppRow;
      var rowIndex = '';
      var rowSkuId;
      var $grid;
      var $quickshopContainer;

      // loop over grids
      $mppProductGrids.each(function(gridCount, grid) {
        $grid = $(grid);
        $mppProducts = $('.js-product-brief', $grid);
        // get row count
        mppRows = _.groupBy($mppProducts, function(element, index) {
          return Math.floor(index / 2); //2 in a row
        });
        mppRows = _.toArray(mppRows);
        mppGridsRows.push(mppRows);

        // even out row height
        setTimeout(function() { // timeout to let fonts render - @font-face FOUT
          site.productView.mppshape.rowHeight(mppRows);
          $mppProductGrids.addClass('grid-fade-in');
        }, 120);

        // add row index and add grid index
        for (var i = 0; i < mppRows.length; i++) {
          $mppRow = $(mppRows[i]);
          rowIndex = gridCount + '-' + i;
          $mppRow.each(function(index, product) {
            // last product in row / $rowSkuId
            rowSkuId = $(product).data('skuId');
            $(product).attr('data-row-index', rowIndex);
          });
          $mppRow.eq(1).addClass('product-brief--second');
          $quickshopContainer = '<li class="product-brief__quickshop-container js-quickshop-container" data-row-index="' + rowIndex + '" data-row-sku-id="' + rowSkuId + '"></li>';
          $mppRow.eq(1).after($quickshopContainer);
          if (i === parseInt(mppRows.length - 1)) {
            // last row // check if only one in row
            if ($mppRow.length === 1) {
              $mppRow.eq(0).after($quickshopContainer);
              $mppRow.addClass('left');
            }
          }
        }
      });
      allMppRows = _.flatten(mppGridsRows, true);
      that.extendedMPPRows = allMppRows;
      var hideAllQS = $(".js-quickshop-hide");
      var showAllQS = $(".js-quickshop-show");
      //var productsArray = page_data['catalog-mpp'].categories[0].products;
      var productsArray;
      if (typeof(page_data["catalog-mpp"].categories) != "undefined") {
        productsArray = page_data['catalog-mpp'].products;
      }
      else {
        if (!!page_data['catalog-mpp'].categories && !!page_data['catalog-mpp'].categories.products) {
          productsArray = page_data['catalog-mpp'].categories[0].products;
        }
        else {
          productsArray = page_data['catalog-mpp'].products;
        }
      }

      //$(".js-product-brief").slice(0,2).each(function() {
      $('.js-product-brief').each(function() {
        var productId = $(this).attr('data-product-id'),
            skuId = $(this).attr('data-sku-id');

        var productData = {};
        if (_.isEmpty(skuId)) {
          productData = _.find(productsArray, function(p) {
            return p.PRODUCT_ID === productId;
          });
        } else {
           productData = _.filter(productsArray, function(p) {
             return p.PRODUCT_ID == productId;
           });

           var skus = [];
           product_data_loop:
           for (var i = 0, j = productData.length; i < j; i++) {
             if (!!productData[i].skus) {
               for (var k = 0, l = productData[i].skus.length; k < l; k++) {
                 if (productData[i].skus[k].SKU_BASE_ID == skuId) {
                   break product_data_loop;
                 }
               }
             }
           }

           productData = productData[i];  // Technically this will default to the last value if all else fails
        }

        var item = site.productView.mobileExtendedMpp({
          containerNode: this,
          productData: productData,
          hideAllQS: hideAllQS,
          showAllQS: showAllQS
        });
      });

      //update row height on resize
      $(window).on('resize', _.debounce(function() {
        site.productView.mppshape.rowHeight(allMppRows);
      }, 250));

      // update row height after inv status is updated
      $(".js-inv-status-list").off('inventory_status_updated');
      $(".js-inv-status-list").off('sku:select');
      $(".js-inv-status-list").on("inventory_status_updated", function(e) {
        var $parentContainer = $(this).parents('.js-product-brief');
        var rowToResize = _.find(allMppRows, function(mppRow) {
          return _.contains(mppRow, $parentContainer[0]);
        });
        site.productView.mppshape.rowHeight([rowToResize]);
      });
    }, // end init
    rowHeight: function(allMppRows) {
      _.each(allMppRows, function(mppRow) {
        _.each(mppRow, function(productContainer) {
          $(productContainer).removeAttr('style');
        });
      });
      //misc flag - extra padding
      $(allMppRows).each(function(index, row) {
        var hasFlag = 0;
        var flagHeight = '19px';
        $(row).each(function(index, product) {
          if ($(product).find('.product-brief__misc-flag').length) {
            hasFlag++;
            flagHeight = $(product).find('.product-brief__misc-flag').outerHeight(true);
          }
        });
        $(row).each(function(index, product) {
          if (hasFlag && $(product).find('.product-brief__misc-flag').length === 0) {
            // check if the spacer already exists before attempting to insert one
            if (!$(product).find('.product-brief__misc-flag-spacer')) {
              var $spacer = $('<div class="product-brief__misc-flag-spacer">');
              $spacer.height(flagHeight);
              $(product).find('.product-brief__header').before($spacer);
            }
          }
        });
      });

      for (var x in allMppRows) {
        var mppRow = allMppRows[x];
        var maxProductHeight = Math.max.apply(null, $(mppRow).map(function() {
          return $(this).outerHeight();
        }).get());
        $(mppRow).outerHeight(maxProductHeight);
      }
    }
  };

  site.productView.mobileExtendedMpp = function(args) {
    var that = {};
    that.$productView = $(args.containerNode);

    if (that.$productView.length < 1)
      return null;
    that.productData = args.productData;

    if (typeof that.productData !== 'object') {
      return null;
    }
    that.productId = args.productData.PRODUCT_ID;
    that.catId = that.productData.PARENT_CAT_ID;
    that.tagIds = that.catId + '~' + that.productId;
    that.skuId = parseInt(that.$productView.attr('data-sku-id'));

    var productSku = _.find(that.productData.skus, function(p) {
      return p.SKU_BASE_ID === that.skuId;
    });

    var pos = that.$productView.hasClass('product-brief--second') ? 1 : 0;
    var qsRowSkuId = that.$productView.next().data('sku-id') || that.$productView.data('sku-id');
    var $qsContainer = $(".js-quickshop-container[data-row-sku-id='" + qsRowSkuId + "']");

    var qs = site.productView.inlineQuickshopForExtendedMPP({
      productData: that.productData,
      position: pos,
      $productContainer: that.$productView,
      $quickshopContainer: $qsContainer,
      active_sku: productSku,
    });

    var $showButton = $('.js-quickshop-show', that.$productView);
    var $hideButton = $('.js-quickshop-hide', that.$productView);
    $showButton.off('click');
    $showButton.on('click', function(evt) {
      evt.preventDefault();
      qs.$quickshopContainer.attr('data-productid', qs.$productContainer.data('product-id'));
      qs.launchWithShape();
      $('.js-quickshop-hide').addClass('hidden'); // hide all hide buttons
      $('.js-quickshop-show').removeClass('hidden'); // show all show buttons
      args.hideAllQS.addClass('hidden'); // hide all hide buttons
      args.showAllQS.removeClass('hidden'); // show all show buttons
      $hideButton.removeClass('hidden');
      $showButton.addClass('hidden');
      if (Drupal.settings.globals_variables.enable_preorder) {
        site.quickShopExposed(qs.active_sku);
      }
    });

    $hideButton.off('click');
    $hideButton.on('click', function(evt) {
      evt.preventDefault();
      site.skuSelect(productSku);
      qs.close();
      $hideButton.addClass('hidden');
      $showButton.removeClass('hidden');
    });

    var $prodImg = $('.product-brief__image', that.$productView);
    var $btnProductPanel = $('.button__quickshop', that.$productView);
    var $inventoryStatusMsg = $("ul.js-inv-status-list", that.$productView);
    $('li', $inventoryStatusMsg).hide();
    if (!!productSku) {
      if (!!productSku.INVENTORY_STATUS) {
        $('.js-inv-status-' + productSku.INVENTORY_STATUS, $inventoryStatusMsg).show();
      }
      if ( site.productData.isComingSoon(productSku) || site.productData.isSoldOut(productSku) ) {
        $btnProductPanel.hide();
      }
    }

    return that;
  };

  site.productView.inlineQuickshopForExtendedMPP = function(args) {
    var that = {};
    $.extend(that, args);

    that.productId = that.productData.PRODUCT_ID;
    that.catId = that.productData.PARENT_CAT_ID;
    that.tagIds = that.catId + '~' + that.productId;

    var qsTemplate = $('script.inline-template[path="quickshop-inline"]').html();

    var skuName = $('.product_brief__shade-name', that.$productContainer);
    var skuPrice = $('.product-brief__price', that.$productContainer);
    var productThumb = $('.product-brief__image', that.$productContainer);

    //skintypes
    var skintypes = _.pluck(that.productData.skus, 'SKIN_TYPE');
    var st = _.filter(that.productData.skus, function(sku) {
      return sku.SKIN_TYPE;
    });
    var skintypes = [];
    var skintypeKey = [];
    var skintypeKeys = [];
    $(st).each(function(index, val) {
      skintypes[index] = [val.SKIN_TYPE, val.SKU_BASE_ID];
    });
    if (skintypes.length > 1) {
      for (var j = 0; j < skintypes.length; j++) {
        if (skintypes[j][0] !== 0) {
          skintypeKey.push(skintypes[j][0]);
        }
      }
      skintypeKey = _.uniq(skintypeKey);
      for (var k = 0; k < skintypeKey.length; k++) {
        skintypeKeys.push([skintypeKey[k], '-']);
      }
      for (var x = 0; x < skintypes.length; x++) {
        for (var i = 0; i < skintypeKeys.length; i++) {
          if (skintypes[x][0] == skintypeKeys[i][0]) {
            skintypeKeys[i][1] = skintypeKeys[i][1] + ',' + skintypes[x][1];
          }
        }
      }
      for (var y = 0; y < skintypeKeys.length; y++) {
        skintypeKeys[y][1] = skintypeKeys[y][1].replace('-,', '');
      }
      if (skintypeKeys.length > 1) {
        for (var p = 0; p < skintypeKeys.length; p++) {
          var glue = 'SKINTYPE_' + skintypeKeys[p][0];
          that.productData[glue] = skintypeKeys[p][1];
        }
        that.productData['skintypes'] = 1;
      }
    }

    if (that.productData.sized) {
      //Mark down Price for Sized Product
      var price2 = (that.active_sku.PRICE2 === undefined) ? '' : that.active_sku.PRICE2;
      var formattedPrice2 = (that.active_sku.formattedPrice2 === undefined) ? '' : that.active_sku.formattedPrice2;
      var formattedPrice = (that.active_sku.formattedPrice === undefined) ? '' : that.active_sku.formattedPrice;
      if (price2) {
        var optionTextHtml =  '<span class="product__price--non-sale">'+ formattedPrice2 +'</span><span class="on-sale  product__price--sale">'+ formattedPrice +'</span>';
        skuPrice.html(optionTextHtml);
      } else {
        if (skuPrice.find('.product_brief__price-loyalty').length > 0) {
          skuPrice.find('.product_brief__price-loyalty').html(that.active_sku.formattedPrice);
        } else {
          skuPrice.html(that.active_sku.formattedPrice);
        }
      }

      skuName.html(that.active_sku.PRODUCT_SIZE).addClass("sized");

      if (skintypeKeys.length > 1) {
        //if (that.active_sku.SKIN_TYPE && that.active_sku.SKIN_TYPE != 8) { //8 - All Skintypes
        var skuSkinType = $('.quickshop-inline__skintype-select option[value=' + that.active_sku.SKIN_TYPE + ']', qsTemplate);
        skuName.html(that.active_sku.PRODUCT_SIZE + " - " + skuSkinType.text());
        skuName.attr("data-skintype", that.active_sku.SKIN_TYPE);
      }
    }

    that.launchWithShape = function() {
      $(document).trigger('MPP:productQV', [that.tagIds]);

      // clear all QS containers on page
      $('.js-quickshop-container').empty();

      that.productData['first_sku'] = that.active_sku;
      var multipleSizes = _.pluck(that.productData.skus, 'PRODUCT_SIZE');
      multipleSizes = _.uniq(multipleSizes);
      multipleSizes = _.compact(multipleSizes).length > 1 ? true : false;
      if (that.productData.sized && multipleSizes) {
        that.productData['multiple_sizes'] = true;
      } else if ((that.productData.sized && !multipleSizes) || that.productData.shaded) {
        that.productData['multiple_sizes'] = false;
      }

      var skus = that.productData.skus;

      $(skus).each(function(index, sku) {
        sku['PRODUCT_ID'] = that.productId;
        var shadeHex = sku.HEX_VALUE_STRING;
        // explode
        var shadeHex = shadeHex.split(',');
        if (shadeHex.length == 1) {
          sku['SWATCH_TYPE'] = 'single';
          sku['HEX_VALUE_1'] = shadeHex[0];
        } else if (shadeHex.length == 2) {
          sku['SWATCH_TYPE'] = 'duo';
          sku['HEX_VALUE_1'] = shadeHex[0];
          sku['HEX_VALUE_2'] = shadeHex[1];
        } else if (shadeHex.length == 3) {
          sku['SWATCH_TYPE'] = 'trio';
          sku['HEX_VALUE_1'] = shadeHex[0];
          sku['HEX_VALUE_2'] = shadeHex[1];
          sku['HEX_VALUE_3'] = shadeHex[2];
        } else if (shadeHex.length == 5) {
          sku['SWATCH_TYPE'] = 'quint';
          sku['HEX_VALUE_1'] = shadeHex[0];
          sku['HEX_VALUE_2'] = shadeHex[1];
          sku['HEX_VALUE_3'] = shadeHex[2];
          sku['HEX_VALUE_4'] = shadeHex[3];
          sku['HEX_VALUE_5'] = shadeHex[4];
        }
        // misc flag
        var sku_misc_flag = sku.MISC_FLAG;
        if (sku_misc_flag == 1) {
          //sku['misc_flag_sku_1'] = true;
          that.productData['misc_flag_sku_1'] = true;
        } else if (sku_misc_flag == 2) {
          //sku['misc_flag_sku_2'] = true;
          that.productData['misc_flag_sku_2'] = true;
        } else if (sku_misc_flag === 3) {
          //sku['misc_flag_sku_3'] = true;
          that.productData['misc_flag_sku_3'] = true;
        } else if (sku_misc_flag === 94 || sku_misc_flag === 5) {
          //sku['misc_flag_sku_4'] = true;
          that.productData['misc_flag_sku_4'] = true;
        } else if (sku_misc_flag === 15) {
          //sku['misc_flag_sku_5'] = true;
          that.productData['misc_flag_sku_5'] = true;
        } else {
          sku.MISC_FLAG = false;
        }
      });

      var qs_render = Mustache.render(qsTemplate, that.productData);
      that.$quickshopContainer.html(qs_render);

      $(document).trigger('productQV:rendered:LoyaltyPrices:popupQS', [that.$quickshopContainer.find('.quickshop-inline__price-size')]);

      //Select the skintype coresponding to the current sku
      $('.quickshop-inline__skintype-select option[value=' + that.active_sku.SKIN_TYPE + ']').attr("selected", "selected");

      if (that.productData.shaded) {

        var shadeArgs = {};

        shadeArgs.productData = that.productData;
        shadeArgs.productContainer = that.$productContainer;
        shadeArgs.qsContainer = that.$quickshopContainer;
        shadeArgs.skuId = that.active_sku.SKU_BASE_ID;

        var qsPicker = new site.ShadeChooser(shadeArgs, that.productData);
      }

      var addCartBtn = site.createAddButton($(".js-add-to-cart", that.$quickshopContainer));
      addCartBtn.updateInvStatus();
      var addFaveBtn = site.addFavoritesButton($(".js-add-to-favorites", that.$quickshopContainer));

      var $invStatusList = $(".js-inv-status-list", that.$quickshopContainer);
      var invStatusList = site.productView.InvStatusList($invStatusList);
      invStatusList.updateInvStatus();

      function updateProductInfo(skuData) {
        var skintype = '';
        var sizeInfo = '';
        var priceInfo = '';
        var $selectedSize;

        if ($skintypeSelect.length) {
          skintype = ' - ' + $skintypeSelect.find('option:selected').text();
        }

        if ($sizeSelect.length && !$skintypeSelect.length) {
          $selectedSize = $sizeSelect.find('option:selected');
        }

        if ($sizeSelect.length && $skintypeSelect.length) {
          $selectedSize = $('.sizeSelectClone').find('option:selected');
        }

        if (!$sizeSelect.length) {
          $selectedSize = $('.quickshop-inline__price-size', that.$quickshopContainer);
        }

        priceInfo = $selectedSize.attr('data-sku-price');
        sizeInfo = $selectedSize.attr('data-sku-size');

        //Mark Down Price Updated for Sized Products
        var price2 = skuData.PRICE2 === undefined ? '' : skuData.PRICE2;
        var formattedPrice2 = (skuData.formattedPrice2 === undefined) ? '' : skuData.formattedPrice2;
        var formattedPrice = (skuData.formattedPrice === undefined) ? '' : skuData.formattedPrice;
        if (price2) {
          priceInfo =  '<span class="product__price--non-sale">'+ formattedPrice2 +'</span><span class="on-sale  product__price--sale">'+ formattedPrice +'</span>';
        } else {
            priceInfo = skuData.formattedPrice;
        }

        skuName.html(sizeInfo + skintype);
        if (skuPrice.find('.product_brief__price-loyalty').length > 0) {
          skuPrice.find('.product_brief__price-loyalty').html(priceInfo);
        } else {
          skuPrice.html(priceInfo);
        }
        productThumb.trigger('sku:select', skuData);

        $(document).trigger('productQV:rendered:LoyaltyPrices', [skuPrice]);
      }

      function updateSizeSelect() {
        $('option', $sizeSelect).prop('disabled', true);
        var selectedSkus = $skintypeSelect.find('option:selected').attr('data-skus').split(',');
        $(selectedSkus).each(function(index, val) {
          $('option', $sizeSelect).filter('[data-sku-base-id=' + val + ']').prop('disabled', false);
        });
        var $sizeSelectClone = $sizeSelect.clone();
        $sizeSelectClone.removeClass('reference');
        $('.sizeSelectClone').remove();
        $sizeSelectClone.addClass('sizeSelectClone');

        $('option:disabled', $sizeSelectClone).remove();
        $sizeSelect.parent().append($sizeSelectClone);
        var skuData;
        $('.sizeSelectClone').on('change.size', function(event) {
          var selectedSize = $(this).find('option:selected');
          var selectedSku = parseInt(selectedSize.attr('data-sku-base-id'));
          skuData = _.find(skus, function(sku) {
            return sku.SKU_BASE_ID === selectedSku;
          });
          site.skuSelect(skuData);

          updateProductInfo(skuData);
        });
        $('.sizeSelectClone').trigger('change.size');
        if (Drupal.settings.globals_variables.enable_preorder) {
          site.quickShopExposed(skuData);
        }
      }

      var $sizeSelect = $('select.quickshop-inline__price-size', that.$quickshopContainer);
      var $skintypeSelect = $('select.quickshop-inline__skintype-select', that.$quickshopContainer);

      // only use skintype as reference, set sku from size select
      $skintypeSelect.change(function(event) {
        //updateSizeSelect();
        if ($sizeSelect.length) {
          updateSizeSelect();
        } else {
          var selectedSku = parseInt($(this).find('option:selected').attr('data-skus'));
          var skuData = _.find(skus, function(sku) {
            return sku.SKU_BASE_ID === selectedSku;
          });
          site.skuSelect(skuData);

          updateProductInfo(skuData);
        }
      });
      $('.quickshop-inline__shade-select').change(function(event) {
        var selectedSku = parseInt($(this).val());
        var skuData = _.find(skus, function(sku) {
          return sku.SKU_BASE_ID === selectedSku;
        });
        if (Drupal.settings.globals_variables.enable_preorder) {
          site.quickShopExposed(skuData);
        }
      });
      $('.js-quickshop-container .js-shade-picker .swatch').on('click', function() {
        var sku = $(document).data('SKU'+$(this).data('sku-base-id'));
        if(Drupal.settings.globals_variables.enable_preorder) {
          site.quickShopExposed(sku);
        }
      });
      if ($sizeSelect.length && $skintypeSelect.length) {
        function updateSizeSelect() {
          $('option', $sizeSelect).prop('disabled', true);
          var selectedSkus = $skintypeSelect.find('option:selected').attr('data-skus').split(',');
          $(selectedSkus).each(function(index, val) {
            $('option', $sizeSelect).filter('[data-sku-base-id=' + val + ']').prop('disabled', false);
          });
          var $sizeSelectClone = $sizeSelect.clone();
          $sizeSelectClone.removeClass('reference');
          if ($('.sizeSelectClone').length) {
            $('.sizeSelectClone').remove();
          }
          $sizeSelectClone.addClass('sizeSelectClone');

          $('option:disabled', $sizeSelectClone).remove();
          $sizeSelect.parent().append($sizeSelectClone);
          $('.sizeSelectClone').on('change.size', function(event) {
            var selectedSize = $(this).find('option:selected');
            var selectedSku = selectedSize.attr('data-sku-base-id');
            var skuData = _.find(skus, function(sku) {
              return sku.SKU_BASE_ID == selectedSku;
            });
            site.skuSelect(skuData);

            updateProductInfo(skuData);

          });
          $('.sizeSelectClone').trigger('change.size');
          if(Drupal.settings.globals_variables.enable_preorder) {
            site.quickShopExposed(skuData);
          }
        }

        updateSizeSelect();
        $('.sizeSelectClone option[data-sku-base-id=' + that.active_sku.SKU_BASE_ID + ']').attr("selected", "selected");
        $('.sizeSelectClone').trigger('change.size');
      } else if ($sizeSelect.length && !$skintypeSelect.length) {
        $sizeSelect.removeClass('reference');
        $sizeSelect.off('change.size');
        $sizeSelect.on('change.size', function(event) {
          var selectedSku = $(this).find('option:selected').attr('data-sku-base-id');
          var skuData = _.find(skus, function(sku) {
            return sku.SKU_BASE_ID == selectedSku;
          });
          site.skuSelect(skuData);
          if(Drupal.settings.globals_variables.enable_preorder) {
            site.quickShopExposed(skuData);
          }
          updateProductInfo(skuData);

          $(this).prev('.select-markdown').remove();
          if ($(this).find('option:selected').hasClass('option-discount-sale')) {
            var selectedElement = $(this).find('option:selected');
            var optionTextHtml = selectedElement.attr("data-markdown-price");
            $(this).before(optionTextHtml);
          }
        });

        $('option[data-sku-base-id=' + that.active_sku.SKU_BASE_ID + ']', $sizeSelect).attr("selected", "selected");
        $sizeSelect.trigger('change.size');

      } else if (!$sizeSelect.length && $skintypeSelect.length) {
        $skintypeSelect.change();
      }

      if (that.position == 1) {
        that.$quickshopContainer.addClass('quickshop-inline--second');
      } else {
        that.$quickshopContainer.removeClass('quickshop-inline--second');
      }
      $(this).hide();
      that.$quickshopContainer.css('display', 'block');
    }; // end launch

    that.close = function() {
      $('.js-quickshop-container').empty();
    };

    return that;
  };

  site.productView.mobileExtendedMppRebuild = function(productData) {
    var $mppProducts = $('.product-brief');
    $mppProducts.removeClass('product-brief--second');
    //remove quickshop
    var $quickshop = $('.js-quickshop-container');
    $quickshop.remove();
    site.productView.mppshape.init(productData);
  };

  Drupal.behaviors.mpp_shade_mobile = {
    attach: function(context, settings) {
      //var productsData = page_data['catalog-mpp'].categories[0].products;
      var productsData;
      if (typeof page_data['catalog-mpp'].categories === 'undefined') {
        productsData = page_data['catalog-mpp'].products;
      } else {
        productsData = page_data['catalog-mpp'].categories[0].products;
      }
      site.productView.mppshape.init(productsData);

      var productThumbs = $('.product-brief__image');

      function isScrolledIntoView(elem) {
        var $elem = $(elem);
        var $window = $(window);

        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();

        return (((elemTop >= docViewTop) && (elemTop <= docViewBottom)) || ((elemBottom >= docViewTop) && (elemBottom <= docViewBottom)));
      }

      function lazyLoading() {
        productThumbs.each(function(i, item) {
          if (isScrolledIntoView(item) && !$(item).hasClass('processed')) {
            $(item).addClass('processed');
            var imageUrl = $(item).attr('data-sku-image');
            $(item).attr('src', imageUrl);
            alternativeImage(item);
            $(item).on('load', function() {
              $(this).removeClass('loader');
              //Set the height of the row once the image is loaded
              var index = 0;
              var $parentContainer = $(item).parents('.product-brief');
              var rowToResize = _.find(site.productView.mppshape.extendedMPPRows, function(mppRow, idx) {
                index = idx;
                return _.contains(mppRow, $parentContainer[0]);
              });
              var startIndex = (index - 2) < 0 ? 0 : index - 2;
              site.productView.mppshape.rowHeight(site.productView.mppshape.extendedMPPRows.slice(startIndex, index + 1));
              //site.productView.mppshape.rowHeight(rowToResize);
              //site.productView.mppshape.rowHeight(site.productView.mppshape.extendedMPPRows);
            }).each(function() {
              if (this.complete) {
                $(this).load();
              }
            }).error(function() {
              if ($(this).hasClass( "show-alter-image" )) {
                var defaultUrl = $(this).attr('data-default-image');
                $(this).attr('src', defaultUrl);
                $(this).removeClass('show-alter-image').addClass('show-alter-image-renew');
              }
            });
          }

          // Mobile Resize - Set Roll Over Plus Position
          var rollOverPlus = $(item).parent('.product_spp').parent('.product-brief').find('.rollover_plus_mobile','.rollover_minus_mobile');
          if (rollOverPlus.length > 0) {
            var imgHeight = $(item).height();
            imgHeight = imgHeight > 35 ? (imgHeight - 35) : imgHeight;
            rollOverPlus.css({'top':imgHeight +'px','right':'15px'});
          }
        });
      }

      function alternativeImage(item) {
        if ($(item).hasClass( "rollover" ) || $(item).hasClass( "rollover-shades" )) {
          var productImage = $(item).attr('data-sku-image');
          var shadeProductName = $(item).hasClass('show-alter-image') ? productImage.substring(41, 55) : productImage.substring(35, 49);
          var rollOver = $(item).hasClass('rollover-shades') ? shadeProductName : productImage.substring(35, 58);
          var rollOverPath = $(item).hasClass('rollover-shades') ? '/media/export/cms/mpp/alternative-images/texture/' + rollOver + '308x424_0_texture.jpg' : '/media/export/cms/mpp/alternative-images/' + rollOver + '_custom.jpg';
          $(item).attr('data-sku-alt-image',rollOverPath);
          var newImage = '<img class="rollover_image hidden" src="'+rollOverPath+'" onError=""></img>';
          $(newImage).insertAfter(item);

          $(item).parent().find("img.rollover_image").load(function() {
            $(item).addClass("rollover-plus-minus");
            $(item).parent().after('<div class="rollover_plus_mobile"><img src="/media/export/cms/mpp/plus.png"></div><div class="rollover_minus_mobile hidden"><img src="/media/export/cms/mpp/minus.png"></div>'+'<div class="rollover_minus_mobile hidden"><img src="/media/export/cms/mpp/minus_black.png">');
          });
        }
      }

      $(".product-brief__image").mouseover(function() {
        var newBgImg = $(this).attr('data-sku-alt-image');
        if ($(this).next()[0].naturalWidth != 0) {
         $(this).attr("src", newBgImg);
        }
        $(this).parent().nextAll(".rollover_plus_mobile").find("img").attr("src","/media/export/cms/mpp/minus_black.png");
      }).mouseout(function() {
        var newBgImg = $(this).attr('data-sku-image');
        $(this).attr("src", newBgImg);
        $(this).parent().nextAll(".rollover_plus_mobile").find("img").attr("src","/media/export/cms/mpp/plus.png");
      });

      $(".rollover_plus_mobile").live("click",function() {
        var img_src = $(this).find("img").attr("src");
        if ( img_src == "/media/export/cms/mpp/plus.png" ) {
          var imgContainer = $(this).prev().find('.product-brief__image');
          var newBgImg = imgContainer.attr('data-sku-alt-image');
          if (imgContainer.next()[0].naturalWidth != 0) {
            imgContainer.attr("src", newBgImg);
          }
          $(this).find("img").attr("src","/media/export/cms/mpp/minus_black.png");
        } else {
          var imgContainer = $(this).prev().find('.product-brief__image');
          var newBgImg = imgContainer.attr('data-sku-image');
          imgContainer.attr("src", newBgImg);
          $(this).find("img").attr("src","/media/export/cms/mpp/plus.png");
        }
      });

      //Show products on scrolling
      $(document).on('scroll', lazyLoading);

      //update row height on resize
      $(window).resize(function() {
        lazyLoading();
      });

      //Load few products images on load so that user won't feel any sluggishness
      productThumbs.slice(0, 8).each(function(i, item) {
        $(item).addClass('processed hidden');
        var imageUrl = $(item).attr('data-sku-image');
        $(item).attr("src", imageUrl);
        alternativeImage(item);
        $(item).on('load', function() {
          $(this).removeClass("loader hidden");
          //Set the height of the row
          site.productView.mppshape.rowHeight(site.productView.mppshape.extendedMPPRows.slice(0,4));
        }).each(function() {
          if (this.complete) {
            $(this).load();
          }
        }).error(function() {
            if ($(this).hasClass( "show-alter-image" )) {
              var defaultUrl = $(this).attr('data-default-image');
              $(this).attr('src', defaultUrl);
              $(this).removeClass('show-alter-image').addClass('show-alter-image-renew');
            }
        });

      });

      lazyLoading();

      //product sort
      site.productSort.allowExtendedMPPSort = true;
      site.productSort.init(productsData);

      //Load the product images after sorting
      var $sortSelect = $('.js-product-sort');
      $sortSelect.change(function(event) {
        lazyLoading();
      });

      // Personalization MPP initialization
      if (Drupal.ELB.hasPersonalization()) {
        site.profile.mobile.MPP(page_data['catalog-mpp']);
      };
    }
  };

  //Shade and SmooshSlider
  site.ShadeChooser = function(args) {
    this.init(args);
  };

  site.ShadeChooser.prototype = {
    productData: null,
    skus: [],
    swatches: '',
    shadeSelects: '',
    productContainer: '',
    shadeNameContainer: '',
    productSPP: '',
    productThumb: '',
    smoosh: '',
    skuId: '',

    wireSmoosh: function() {
      var self = this;

      setTimeout(function() {
        self.smoosh.slick({
          lazyLoad: 'progressive',
          centerPadding: '50%',
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          onAfterChange: function(slider) {
            var $currentSlide = $(slider.$slides).eq(slider.currentSlide);
            var skuBaseId = parseInt($currentSlide.attr('data-sku-base-id'));
            var skuData = _.find(self.productData.skus, function(p) {
              return p.SKU_BASE_ID === skuBaseId;
            });
            site.skuSelect(skuData);

            var selectedSkuBaseId = skuData.SKU_BASE_ID;
            self.updateSelects(selectedSkuBaseId);
            self.updateSwatches(selectedSkuBaseId);
            self.updateProductInfo(skuData);
          }
        });
      }, 200); //give the first image some time to load

      //hook into shade picker
      self.smoosh.on('sku:select', function(e, skuData) {
        var skuId = skuData.SKU_BASE_ID;
        var $smooshes = $('.smoosh-list-item', self.smoosh);
        var smooshIndex = $smooshes.filter('[data-sku-base-id=' + skuId + ']').index();
        var currentSlide = self.smoosh.slick('slickCurrentSlide');
        if (smooshIndex !== currentSlide) {
          self.smoosh.slick('slickGoTo', smooshIndex);
        }
        self.updateDownPrice(skuData);
        e.stopPropagation();
      });
    },

    wireSwatches: function() {
      var self = this;
      self.swatches.on('click', function(e) {
        e.preventDefault();
        var selectedSkuBaseId = $(this).attr('data-sku-base-id');
        self.updateSwatches(selectedSkuBaseId);
        var skuData = self.skus[selectedSkuBaseId];
        site.skuSelect(skuData);

        self.updateSelects(selectedSkuBaseId);

        self.updateProductInfo(skuData);
      });
    },
    wireShadeSelects: function() {
      var self = this;
      self.customSelects(true);
      self.shadeSelects.on('change', function(e) {
        var selectedSkuBaseId = $(this).val();
        self.updateSelects(selectedSkuBaseId);
        var skuData = self.skus[selectedSkuBaseId];
        site.skuSelect(skuData);

        self.updateSwatches(selectedSkuBaseId);

        self.updateProductInfo(skuData);
      });
    },
    customSelects: function(init) {
      var self = this;
      self.shadeSelects.each(function(index, val) {
        if (init) {
          $(this).selectBox({
            mobile: true
          });
        } else {
          $(this).selectBox('refresh');
        }
        var $shadeSelect = $(this).selectBox('control');
        var $shadeSelectOption = $($shadeSelect).data('selectBox-options'); // extra $() for iPad

        if ($shadeSelectOption != null) {
          var $shadeMenuOptions = $shadeSelectOption.find('li a');
          // add shade divs to custom select
          $shadeMenuOptions.each(function() {
            var shadeSku = parseInt($(this).attr('rel'));
            var shadeProductData = _.find(self.productData.skus, function(sku) {
              return sku.SKU_BASE_ID === shadeSku;
            });
            var shadeHex = shadeProductData.HEX_VALUE_STRING;

            // explode
            shadeHex = shadeHex.split(',');

            //sort swathes
            var swatchType, hexValue1, hexValue2, hexValue3, hexValue4, hexValue5;
            if (shadeHex.length === 1) {
              swatchType = 'swatches--single';
              hexValue1 = shadeHex[0];
            } else if (shadeHex.length === 2) {
              swatchType = 'swatches--duo';
              hexValue1 = shadeHex[0];
              hexValue2 = shadeHex[1];
            } else if (shadeHex.length === 3) {
              swatchType = 'swatches--trio';
              hexValue1 = shadeHex[0];
              hexValue2 = shadeHex[1];
              hexValue3 = shadeHex[2];
            } else if (shadeHex.length === 4) {
              swatchType = 'swatches--quad';
              hexValue1 = shadeHex[0];
              hexValue2 = shadeHex[1];
              hexValue3 = shadeHex[2];
              hexValue4 = shadeHex[3];
            } else if (shadeHex.length === 5) {
              swatchType = 'swatches--quint';
              hexValue1 = shadeHex[0];
              hexValue2 = shadeHex[1];
              hexValue3 = shadeHex[2];
              hexValue4 = shadeHex[3];
              hexValue5 = shadeHex[4];
            }

            var $swatchContainer = $('<div/>', {
              'class': 'swatch__container ' + swatchType
            });
            for (var i = 0; i < shadeHex.length; i++) {
              var $swatchDiv = $('<div/>', {
                'class': 'swatch--' + (i + 1),
                'style': 'background-color:' + shadeHex[i]
              });
              $swatchContainer.append($swatchDiv);
            }

            // add to li
            $(this).prepend($swatchContainer).clone(true);
            // add to label
            if ($(this).parent().hasClass('selectBox-selected')) {
              var $shadeSelectLabel = $shadeSelect.parent().find('.selectBox-dropdown');
              if ($('.swatch__container', $shadeSelectLabel).length) {
                var $clone = $swatchContainer.clone(true);
                $('.swatch__container', $shadeSelectLabel).replaceWith($clone);
              } else {
                var $clone = $swatchContainer.clone(true);
                $shadeSelectLabel.prepend($clone);
              }
            }

          });
        }
      });
    },
    updateSwatches: function(skuId) {
      var self = this;
      self.swatches.removeClass("selected");
      self.swatches.filter("[data-sku-base-id=" + skuId + "]").addClass("selected");
    },
    updateSelects: function(skuId) {
      var self = this;
      self.shadeSelects.val(skuId);
      self.customSelects(false);
    },

    updateDownPrice : function(skuData) {
      var price2 = (skuData.PRICE2 === undefined) ? '' : skuData.PRICE2;
      var formattedPrice2 = (skuData.formattedPrice2 === undefined) ? '' : skuData.formattedPrice2;
      var formattedPrice = (skuData.formattedPrice === undefined) ? '' : skuData.formattedPrice;
      var productSize = (skuData.PRODUCT_SIZE === undefined) ? '' : skuData.PRODUCT_SIZE;
      var priceNode = $('.quickshop-inline__price-size').not('select');
      if (price2) {
        productSize = (productSize!== null ? (productSize + '  ') : '');
        var optionTextHtml = '<span class="product__price--non-sale">'+ formattedPrice2 +'</span>  <span class="on-sale  product__price--sale">'+ formattedPrice +'</span>  ' +  productSize;
        priceNode.html(optionTextHtml);
      } else {
        if (productSize !== null && productSize !== '') {
          if (priceNode.find('.js-price-loyalty').length > 0) {
            priceNode.find('.js-price-loyalty').html(skuData.formattedPrice);
            priceNode.find('.js-loyalty-size').html(productSize);
            $(document).trigger('productQV:rendered:LoyaltyPrices:popupQS', [priceNode]);
          } else {
            priceNode.html(skuData.formattedPrice + '  ' + productSize);
          }
        } else {
          if (priceNode.find('.js-price-loyalty').length > 0) {
            priceNode.find('.js-price-loyalty').html(skuData.formattedPrice);
            $(document).trigger('productQV:rendered:LoyaltyPrices:popupQS', [priceNode]);
          } else {
            priceNode.html(skuData.formattedPrice);
          }
        }
      }
    },

    updateProductInfo: function(skuData) {
      var self = this;
      self.shadeNameContainer.once().html(skuData.SHADENAME);
      self.productSPP.attr("href", self.productSPP.attr("data-product-url") + "#" + skuData.SKU_BASE_ID);
      self.productThumb.once().trigger('sku:select', skuData);
      var skuImg = Array.isArray(skuData.MEDIUM_IMAGE) ? skuData.MEDIUM_IMAGE[0] : skuData.MEDIUM_IMAGE;
      self.productThumb.once().attr('src', skuImg);
    },
    init: function(args) {
      var self = this;
      self.productData = args.productData;
      self.productContainer = args.productContainer;
      self.qsContainer = args.qsContainer;
      self.shadeNameContainer = $(".product_brief__shade-name", self.productContainer);
      self.productSPP = $(".product_spp", self.productContainer).add($(".quickshop-inline__details", self.qsContainer));
      self.productThumb = $('.product-brief__image', self.productContainer);
      self.smoosh = $('.smoosh-list', self.qsContainer);
      self.skuId = args.skuId;

      var pid = self.productData.PRODUCT_ID;
      for (var i = 0; i < self.productData.skus.length; i++) {
        var s = self.productData.skus[i];
        self.skus[s.SKU_BASE_ID] = s;
      }

      //Init shade smoosh
      self.wireSmoosh();

      //check for swatches
      self.swatches = $("a.swatch", self.qsContainer);
      if (self.swatches.length > 0) {
        self.wireSwatches(self.swatches);
      }
      //check for selects
      self.shadeSelects = $("select.js-sku-menu", self.qsContainer);
      if (self.shadeSelects.length > 0) {
        self.wireShadeSelects(self.shadeSelects);
      }

      setTimeout(function() {
        self.swatches.filter('a[data-sku-base-id=' + self.skuId + ']').click();
      }, 200); //give the first image some time to load
    }
  };
})(jQuery);

